export function hskTypeName(title, xam_type, alphabet, searchbox, bookmark) {
  let local = localStorage.getItem("language");
  if (local == "zh") {
    local = "Chinese";
  } else if (local == "en") {
    local = "English";
  }
  let ishskTypeNameData = {
    title: title,
    url: window.location.href,
    referrer_host: document.referrer?.match(/:\/\/(.[^/]+)/)?.[1],
    referrer: document.referrer,
    xam_type: xam_type,
    alphabet: alphabet,
    searchbox: searchbox,
    bookmark: bookmark,
    language: local,
  };
  let hskTypeNameData = {};
  for (let key in ishskTypeNameData) {
    if (ishskTypeNameData[key]) {
      hskTypeNameData[key] = ishskTypeNameData[key];
    }
  }
  return hskTypeNameData;
}
export function getTime(time) {
  function add0(m) {
    return m < 10 ? "0" + m : m;
  }
  var y = time.getFullYear();
  var m = time.getMonth() + 1;
  var d = time.getDate();
  var h = time.getHours();
  var mm = time.getMinutes();
  return y + "/" + add0(m) + "/" + add0(d) + " " + add0(h) + ":" + add0(mm);
}
